module.exports = __webpack_public_path__ + "img/p9.2b1efe0e.png";